<template>
    <div class="fixed bottom-0 w-full bg-gray-800 p-4">
        <p class="text-center text-gray-500">Contact us on <a class="text-blue-400" href="t.me/helpinghands_covid">Telegram</a></p>
    </div>
</template>